"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Fields = require("./Fields");

var _Fields2 = _interopRequireDefault(_Fields);

require("../../assets/css/components/form/RadioButtonGroup.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioButtonGroup = function (_React$Component) {
    _inherits(RadioButtonGroup, _React$Component);

    function RadioButtonGroup(props) {
        _classCallCheck(this, RadioButtonGroup);

        var _this = _possibleConstructorReturn(this, (RadioButtonGroup.__proto__ || Object.getPrototypeOf(RadioButtonGroup)).call(this, props));

        _this.componentWillReceiveProps = function (nextProps) {
            if (nextProps.value !== _this.state.value) _this.setState({ value: nextProps.value });
        };

        _this.stringToBoolean = function (string) {
            switch (String(string).toLowerCase().trim()) {
                case "true":case "sim":case "1":
                    return true;
                case "false":case "nao":case "não":case "0":case null:
                    return false;
                default:
                    return false;
            }
        };

        _this.onChange = function (event) {
            var value = _this.stringToBoolean(event.target.value);
            if (_this.state.value !== value) {
                _this.setState({
                    value: event.target.value
                });
                if (_this.props.onChange) _this.props.onChange(event);
            }
        };

        _this.radioMapper = function () {
            if (_this.props.options) return _this.props.options.map(function (o, i) {
                return _react2.default.createElement(
                    "div",
                    { className: "mtd-radio-check" + (_this.props.inline ? " inline" : "") },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: _this.props.name + i, className: _this.state.value === o.value ? "active" : "" },
                        o.text
                    ),
                    _react2.default.createElement("input", { type: "radio", value: o.value, id: _this.props.name + i, name: _this.props.name, onClick: _this.onChange }),
                    _react2.default.createElement("span", { "aria-hidden": "true", className: "checkbox-radio-focus" })
                );
            });
        };

        _this.state = {
            value: null
        };
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    _createClass(RadioButtonGroup, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                _Fields2.default,
                this.props,
                _react2.default.createElement(
                    "div",
                    { className: "mtd-radio" },
                    this.radioMapper()
                )
            );
        }
    }]);

    return RadioButtonGroup;
}(_react2.default.Component);

exports.default = RadioButtonGroup;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/form/RadioButtonGroup.js
// module id = 1123
// module chunks = 0